<wdx-form-field
    [locked]="formElement?.isLocked"
    [label]="formElement?.label | translateTokenisedString"
    [guidanceText]="formElement?.guidanceText | translateTokenisedString"
    [isSensitive]="formElement?.isSensitive ?? undefined"
    [isRequired]="formElement?.isRequired ?? undefined"
    [labelForId]="inputId"
    [validationErrorMessage]="
        formControl?.touched
            ? (formControl?.errors | validationErrorMessage)
            : ''
    "
    [warningMessage]="warningText"
>
    @if (fileIndexes?.length) {
        @for (fileIndex of fileIndexes; track $index; let i = $index) {
            <wdx-document-info
                class="d-block mb-1 w-100"
                [fileIndex]="fileIndex"
                (downloadClicked)="downloadClicked()"
                [customHeaders]="formElement?.customHeaders"
            >
                @if (!isDisabled) {
                    <wdx-icon-button
                        class="ms-2"
                        size="sm"
                        wdxStyle="outline-primary"
                        (wdxOnClick)="onDeleteFile(fileIndex)"
                    >
                        <wdx-icon icon="trash-alt"></wdx-icon>
                    </wdx-icon-button>
                }
            </wdx-document-info>
        }
    }

    @if (
        formElement.max === undefined ||
        (fileIndexes?.length || 0) < (formElement.max || 99)
    ) {
        <wdx-file-upload
            data-cy="document-upload"
            [disabled]="isDisabled ? true : false"
            [imageUpload]="formElement.fieldType === FormFieldType.ImageUpload"
            [customEndpoint]="formElement?.customEndpoint"
            [customHeaders]="formElement?.customHeaders"
            [reset]="resetUpload"
            (fileUploaded)="onFileUploaded($event)"
        ></wdx-file-upload>
    }
</wdx-form-field>
